import { useLazyQuery } from "@apollo/client";
import { useState, useEffect } from "react";
import { GET_ORIS_QUERY } from "../Queries/GetOrisQuery";
import { LOCAL_STORAGE_KEYS } from "../Constants/localStorageKeys";
import { checkLocalStorageAge, localGetData, localStoreData } from "../utils/utils";

export const useFetchOris = (onlineState) => {

  const [oriList, setOriList] = useState([]);
  const [getOris, { loading: orisLoading, error: orisError }] = useLazyQuery(GET_ORIS_QUERY, {
    context: { serializationKey: "incidentQueue" },
    fetchPolicy: 'no-cache',
    // onError: (error) => { console.error(JSON.stringify(error)) },
    onCompleted: (data) => {
      if (data) {
        setOriList(data.getOris);
        localStoreData(data, LOCAL_STORAGE_KEYS.ORIS);
      }
    }
  });

  useEffect(() => {
    // Only check the age if the user is online
    if (onlineState) {
      const isFresh = checkLocalStorageAge(LOCAL_STORAGE_KEYS.ORIS, 8);

      if (!isFresh) {
        getOris(); // Fetch fresh data when local storage is stale
      } else {
        // Data is fresh, use it from local storage
        setOriList(localGetData(LOCAL_STORAGE_KEYS.ORIS)?.getOris);
      }
    } else {
      // If offline, load ORI data from local storage without clearing the key
      setOriList(localGetData(LOCAL_STORAGE_KEYS.ORIS)?.getOris);
    }
  }, [getOris, onlineState]);

  return { oriList, orisLoading, orisError };
};
